<template>
  <!--在线签到系统-->
  <div>
    <div class="mj_one">
      <p>{{ config.signinLocation }}</p>
      <p>签到模式：{{ config.signinMode === 1 ? "查询签到" : "" }}</p>
    </div>
    <ul class="qd_type qd_type2">
      <li
        v-for="(oper, index) in operation"
        :key="index"
        :class="{ sel: oper.key == currentComponent }"
        @click="navigate(oper.key)"
      >
        {{ oper.value }}
      </li>
    </ul>
    <a-spin :spinning="loading">
      <ul class="qd_four">
        <div style="padding-top: 10px">
          <p v-html="displaySettings"></p>
        </div>
        <li class="li_search">
          <input
            disabled
            type="text"
            class="txt"
            v-model="certificateCode"
            placeholder="扫描绑定证件code，如不绑定请忽略"
          />
          <button class="btn" @click="scanIt">扫描</button>
        </li>
        <template v-if="!loading">
          <li class="li">
            签到状态： {{ history.status ? "已签到" : "未签到" }}
          </li>
          <li class="li">签到时间： {{ history.createdTime }}</li>
          <li class="li">签到次数： {{ history.count }}</li>
          <li class="li">签到地点： {{ history.signLocations.toString() }}</li>
        </template>
      </ul>
      <div class="qd_five">
        <a-button :loading="btnLoading" class="btnQianDao" shape="circle" size="large" @click="submit">签到</a-button>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import { cloneDeep } from "lodash-es";
export default {
  name: "",
  data() {
    return {
      tabid: 0,
      loading: false,
      btnLoading: false,
      alias: "",
      configuration: "",
      registerId: "",
      certificateCode: "", // 扫描证件code
      appSettings: [], // 显示配置
      displaySettings: "",
      currentComponent: "",
      signConfig: {
        signinLocation: "",
        signinMode: "",
      },
      history: {
        status: false,
        createdTime: null,
        count: 0,
        signLocations: [],
      }, // 历史
      operation: [
        { key: "Accurate", value: "精确查询" },
        { key: "Vague", value: "模糊查询" },
        { key: "Team", value: "团体签到" },
        { key: "ScanCode", value: "扫码签到" },
      ],
    };
  },
  mounted() {
    if (this.scannedCode) {
      this.changeCertificateCode(this.scannedCode);
      this.certificateCode = this.scannedCode;
      this.clearScannedCode();
    }
    const alias = this.$route.query.alias;
    const registerId = this.$route.query["register-id"];
    const configuration = this.$route.query.configuration;
    const mode = this.$route.query.mode;
    if (!!mode) {
      this.currentComponent = mode;
    }
    if (!configuration || !registerId) {
      this.$message.error("您的链接无效");
      return;
    }
    this.alias = alias;
    this.registerId = registerId;
    this.configuration = configuration;
    this.loading = true;
    Promise.all([this.getDetail(configuration, registerId), this.getHistorySign(registerId)]).finally(() => {
      this.loading = false;
    })
    // this.getDetail(configuration, registerId);
    // this.getHistorySign(registerId);
  },
  computed: {
    ...mapState("scanStore", ["scannedCode"]),
    ...mapGetters({
      config: "signStore/getConfig",
    }),
  },
  methods: {
    ...mapMutations("scanStore", ["clearScannedCode"]),
    // 打开扫一扫
    scanIt() {
      this.$router.push({ path: "/scan" });
    },
    async getDetail(alias, registerId) {
      const res = await this.$get(
        `/api/SigninConfig/GetDetailByAliasAndRegisterId/${alias}/${registerId}`
      );
      if (res.code === 200 && res.data) {
        this.displaySettings = res.data;
      }
    },
    // 获取历史签到记录
    async getHistorySign(registerId) {
      const res = await this.$get(
        `/api/SigninConfig/GetHistorySign/${registerId}`
      );
      if (res.code === 200) {
        this.history = { ...res.data };
      }
    },
    // 跳转
    navigate(mode) {
      const alias = this.$route.query.alias;
      const configuration = this.$route.query.configuration;
      this.$router.push(
        `/sign/search?alias=${alias}&configuration=${configuration}&mode=${mode}`
      );
    },
    // 修改证件code
    async changeCertificateCode(code) {
      const { configuration } = this.$route.query;
      const registerId = this.$route.query["register-id"];

      const res = await this.$put("/api/SigninConfig/ChangeCertificateCode", {
        CertificateCode: code,
        registerId,
        signId: configuration,
      });
      if (res.code === 200) {
        this.$message.success("证件code绑定成功");
      }
    },
    // 签到
    async submit() {
      this.btnLoading = true;
      let res;
      try {
        const data = {
          registerId: this.registerId,
          signId: this.configuration,
        };
        res = await this.$post("/api/SigninConfig/SignIn", data);
        if (res.code === 200) {
          this.$message.success("签到成功");
          // 加了跳转后其实刷不刷新签到数据无所谓了，如果需要再放开
          // this.getHistorySign(this.registerId);
          if (!!this.currentComponent) {
            this.navigate(this.currentComponent);
          }
        }
      } catch (error) {
        this.$message.error("签到失败");
        return;
      } finally {
        this.btnLoading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.example {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}
</style>
